import { render, staticRenderFns } from "./patchCardlList.vue?vue&type=template&id=e3b97496&"
import script from "./patchCardlList.vue?vue&type=script&lang=js&"
export * from "./patchCardlList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports